/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerMarketService = {

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async getDefault(params) {
    const requestScreenData = {
      url: "api/CustomerMarket",
      top: "1",
      filter: `IsDefault eq 'Y'`,
    };
    if (params) {
      if (params.select) requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerMarketService };
